import SympleCrypto from 'simple-crypto-js';
const createCrypto=()=>{
    let key='kooku';
    const cryptoInstance=new SympleCrypto(key);

    function setSecret(secret){
        if(!secret)throw new Error('no secret value provided');
        if(secret === key)return;
        key=secret;
        cryptoInstance.setSecret(key);
    }

    function encrypt(key){
        return cryptoInstance.encrypt(key);
    }

    function decrypt(value){
        return cryptoInstance.decrypt(value)
    }

    return {
        encrypt,
        decrypt,
        setSecret
    }

}

const crypto=createCrypto();

export default crypto;